import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import CalendarModal from "../calendar/CalendarModal";
import { Button, Col, Container, Row } from 'react-bootstrap';
import moment from 'moment';
import '../css/general.css';
import config from "../etc/config.json";
import { getUnicodeOrImageFlag, resultEmoji, truncateString } from "../common/Helpers";
import { C4FStatusContext, ReferenceDataContext, SitterUserInformationContext, PollContext } from "./App";
import packageJson from '../../package.json';
import C4FSimpleTable from "../common/C4FSimpleTable";

function Home(props) {
  const { browserInfo } = useContext(C4FStatusContext);
  const { polls, showPoll, refreshPolls } = useContext(PollContext);
  const [raceEditions, setRaceEditions] = useState([]);
  const [generalInformation, setGeneralInformation] = useState(null);
  const { handleBackendRequest } = useContext(C4FStatusContext);
  const { countries } = useContext(ReferenceDataContext);
  const { sitterUserInformation } = useContext(SitterUserInformationContext);
  const navigate = useNavigate();
  const mounted = useRef(false);
  const [showCalendarRaceId, setShowCalendarRaceId] = useState(null);
  const [showCalendarRaceEditionId, setShowCalendarRaceEditionId] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const handleCloseCalendar = () => setShowCalendar(false);

  function handleShowCalendarFromEdition(raceEdition) {
    if (mounted.current) {
      setShowCalendarRaceId(raceEdition.race.id);
      setShowCalendarRaceEditionId(raceEdition.id);
      setShowCalendar(true);
    }
  };

  function showRace(raceEditionId) {
    navigate('/race', { state: { raceEditionId: raceEditionId } });
  }

  function handleShowPoll(poll) {
    showPoll(poll.id);
  }

  function todaysStage(currentStage, numberOfStages) {
    if (currentStage < 2) {
      return 1;
    }
    else if (currentStage > numberOfStages) {
      return numberOfStages;
    }
    else if (currentStage <= numberOfStages) {
      return currentStage;
    }
    else {
      return 0;
    }
  }

  useEffect(() => {
    handleBackendRequest('GET', '/generalInformation', null, null, setGeneralInformation);
    handleBackendRequest('GET', '/raceEdition', null, { context: 'today' }, setRaceEditions);
  }, []);

  useEffect(() => {
    mounted.current = true;
  }, []);

  useEffect(() => {
    return () => {
      mounted.current = false;
    }
  }, []);

  if (generalInformation !== null)
    return (
      <Container fluid className="m-0 p-0 justify-content-center">
        <Row className="d-flex mt-1 p-1 justify-content-center">
          <Col className="ml-2 mr-1 my-1 p-0" style={{ minWidth: 400, maxWidth: "80vw" }}>
            <h5><u>Today's Races</u></h5>
            <CalendarModal key={'calendar' + showCalendar}
              raceId={showCalendarRaceId}
              selectedRaceEditionId={showCalendarRaceEditionId}
              show={showCalendar}
              handleClose={handleCloseCalendar} />
            <div className="m-0 p-0" style={{ maxHeight: 400, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
              <table className="table table-sm table-striped">
                <thead>
                  <tr>
                    <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Start</th>
                    <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Race</th>
                    <th className="th-infotable" scope="col">Day</th>
                    <th className="th-infotable" scope="col">Cat.</th>
                    <th className="th-infotable" scope="col">Teams</th>
                    <th className="th-infotable" scope="col">Show</th>
                    <th className="th-infotable" scope="col">Race at</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {raceEditions
                    .sort(function (a, b) { return a.startingTime - b.startingTime })
                    .map((raceEdition) => (
                      <tr>
                        <td className="td-infotable" style={{ textAlign: "left" }}>{raceEdition.startingTime}:00 CET</td>
                        <td className="td-infotable" style={{ textAlign: "left" }}>
                          {getUnicodeOrImageFlag(countries, raceEdition.race.country, browserInfo)}
                          &nbsp;
                          <a href="#" onClick={() => handleShowCalendarFromEdition(raceEdition)} style={{ color: "black" }}>
                            {raceEdition.race.raceName + (raceEditions.some(re => re.race.raceName === raceEdition.race.raceName && re.startingTime === raceEdition.startingTime && re.group !== raceEdition.group) ? ' (' + raceEdition.group + ')' : '')}
                          </a>
                        </td>
                        <td className="td-infotable">{todaysStage(raceEdition.currentStage, raceEdition.race.numberOfStages)} / {raceEdition.race.numberOfStages}</td>
                        <td className="td-infotable">{raceEdition.race.category}</td>
                        <td className="td-infotable">{raceEdition.numberOfParticipants}</td>
                        <td className="td-infotable">
                          {(() => {
                            if (raceEdition.raceEditionStatus === 'Inscription')
                              return <Link to={{ pathname: '/inscription' }}
                                className={'btn btn-sm btn-outline-success ' + (sitterUserInformation ? 'disabled' : '')}>Inscription</Link>
                            else if (raceEdition.raceEditionStatus === 'Cancelled')
                              return <Button variant="outline-danger" size="sm" disabled>Cancelled</Button>
                            else if (raceEdition.raceEditionStatus === 'Completed')
                              return <Button variant="outline-secondary" size="sm" onClick={() => showRace(raceEdition.id)}>Result</Button>
                            else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'NotStarted' && raceEdition.currentSector === 1)
                              return <Button variant="outline-primary" size="sm" onClick={() => showRace(raceEdition.id)}>Startlist</Button>
                            else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'NotStarted')
                              return <Button variant="outline-primary" size="sm" onClick={() => showRace(raceEdition.id)}>Live</Button>
                            else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'Completed')
                              return <Button variant="outline-secondary" size="sm" onClick={() => showRace(raceEdition.id)}>Stage Result</Button>
                            else
                              return <Button variant="outline-primary" size="sm" onClick={() => showRace(raceEdition.id)}>Live</Button>
                          })()}
                        </td>
                        <td className="td-infotable">
                          {(() => {
                            if (raceEdition.raceEditionStatus === 'Inscription')
                              return "Inscription"
                            else if (raceEdition.raceEditionStatus === 'Completed')
                              return "Finish"
                            else if (raceEdition.raceEditionStatus === 'Cancelled')
                              return null;
                            else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'NotStarted' && raceEdition.currentSector === 1)
                              return "Start"
                            else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'NotStarted')
                              return "km " + raceEdition.currentSector
                            else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'Completed')
                              return "Finish"
                            else
                              return raceEdition.sprintStepsLeft * 50 + "m left"
                          })()}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </Col>
          <Col className="p-0 m-1" style={{ minWidth: 200, maxWidth: 350 }}>
            <h5 className="ml-2 text-left"><u>C4F News (v{packageJson.version})</u></h5>
            <div className="border border-secondary p-1 m-0" style={{ maxHeight: 300, minWidth: 200, maxWidth: 350, overflow: "auto", backgroundColor: 'rgba(251, 253, 255, 1)' }}>
              {generalInformation.news.map(news =>
                <div>
                  <p className="ml-2 mt-1 mb-0 text-left" style={{ color: "#c61c18", padding: 0, marginBottom: "0px" }}>
                    {moment(news.date).format('dd, D MMM YYYY')}
                  </p>
                  <p className="ml-2 mt-1 mb-0 pb-3 text-left" style={{ wordBreak: "break-word", padding: 0, marginBottom: "0px" }}>
                    {news.message}
                  </p>
                </div>
              )}
            </div>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mt-1 p-1">
          <Col>
          
          </Col>
        </Row>
        <Row className=" d-flex justify-content-center mt-1 p-1">
          <Col className=" ml-2 mr-1 my-1 p-0">
            {!sitterUserInformation ? 
              <>              
                <h5 className="text-left">
                  <u>Current Polls</u>
                  <Button className="ml-2 py-0" size="sm" variant={'secondary'}
                    onClick={() => showPoll()}>All Polls</Button>
                  <Button className="ml-1 py-0" size="sm" variant={'success'}
                    onClick={() => refreshPolls()}>Refresh {'\u21BB'}</Button>
                </h5> 
                <div className="border border-secondary m-0 p-0" style={{ maxHeight: 200, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(251, 253, 255, 1)' }}>
                  {polls && polls.filter(p => p.status === 'InProgress').length > 0 ? 
                    <C4FSimpleTable 
                      key={'polls'}
                      hideFilterButtons={true}
                      hideColumnVisibility={true}
                      data={polls.filter(p => p.status === 'InProgress').map(p => ({
                        ...p,
                        titleFormatted: truncateString(p.title, 40),
                        questions: p.items.length,
                        votedFormatted: resultEmoji(p.voted ? 'OK' : 'NOK')
                      }))}
                      rowMetadata={[
                        { columnName: 'titleFormatted', columnDescription: 'Title', cellClickEvent: handleShowPoll },
                        { columnName: 'status', columnDescription: 'Status' },
                        { columnName: 'questions', columnDescription: '# Questions' },
                        { columnName: 'totalParticipants', columnDescription: '# Votes' },
                        { columnName: 'votedFormatted', columnDescription: 'Voted' },
                      ]}
                    />
                    :
                    <p>No active polls currently.</p>
                  }
                </div>
              </>
            : null }
            <h5 className="text-left"><u>Recent Race Results</u></h5>
            <div className="border border-secondary m-0 p-0" style={{ maxHeight: 400, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(251, 253, 255, 1)' }}>
              {generalInformation.results.map(result =>
                result.message.split('\n').map(line =>
                  <span >{line}<br /></span>
                )
              )}
            </div>
          </Col>
          <Col className="p-0 m-1" style={{ minWidth: 200, maxWidth: 350 }}>
            <h5 className="ml-2 text-left"><u>Interviews</u></h5>
            <div className="border border-secondary p-1 m-0" style={{ maxHeight: 400, minWidth: 200, maxWidth: 350, overflow: "auto", backgroundColor: 'rgba(251, 253, 255, 1)' }}>
              {generalInformation.interviews.map((interview, index) => (
                <div>
                  <span className="text-primary ml-2">Interview with {interview.teamName} ({interview.time}):<br></br></span>
                  {interview.items.map((interviewItem) => (
                    <>
                      <span className="ml-2" style={{ color: "red" }}>{interviewItem.question}<br></br></span>
                      <span className="ml-2">{interviewItem.answer}<br></br></span>
                    </>
                  ))}
                  <br></br>
                </div>
              ))}
            </div>
          </Col>
        </Row>
        <div className="row d-flex p-0 m-1 justify-content-center">
          <div className="col" style={{ textAlign: "center" }}>
            <br />
            <br />
            <br />
            <br />
            <br />
            <p>Visit the <a href={config.FORUM_BASE_URL} target="_blank" rel="noreferrer">Forum</a> and <a href="http://radsportfreaks.de/RSFForum/viewforum.php?f=22" target="_blank" rel="noreferrer">discuss recent races</a>.</p>
            <br />
            <br />
            <br />
          </div>
        </div>
      </Container>
    );
  else return null;
}

export default Home;
